export const translations = {
  it: {
    // Pannello principale
    kioskSubtitle: 'Postazione ingresso',
    btnRegister: 'Registrati',
    btnBadge: 'Badge',
    btnExit: 'Uscita',
    adminLink: 'Accesso amministratore',
    cancel: 'Annulla',
    close: 'Chiudi',
    confirm: 'Conferma',

    // Modale Registrati
    registerTitle: 'Registrati',
    registerSubtitle: 'Compila i tuoi dati per completare la registrazione.',
    fieldNome: 'Nome *',
    fieldCognome: 'Cognome *',
    fieldBadge: 'Numero badge *',
    fieldRiferimento: 'Persona di riferimento',
    fieldEmail: 'Email',
    fieldNote: 'Note',
    emailPlaceholder: 'nome@esempio.it',
    emailHint: 'Facoltativa: se la inserisci, ti mandiamo una copia dei documenti privacy e sicurezza via email.',
    referenceSelectedHint: 'La persona selezionata riceverà una notifica via email.',
    fieldDitta: 'Ditta',
    fieldTelefono: 'Telefono',
    fieldRuolo: 'Ruolo',
    fieldDocumentType: 'Tipo documento',
    fieldDocumentNumber: 'Numero documento',
    docTypePlaceholder: 'Seleziona…',
    docTypeIdCard: "Carta d'identità",
    docTypeLicense: 'Patente',
    docTypePassport: 'Passaporto',
    optional: '(opzionale)',
    consentPrivacyPrefix: "Ho letto e accetto l'",
    linkPrivacy: 'informativa privacy',
    linkSecurity: 'informativa sicurezza',
    consentToRead: 'Tocca per leggere e accettare',
    consentDone: 'Letta e accettata',
    docAcceptButton: 'Ho letto, accetto',
    submitting: 'Invio in corso…',
    registerSuccessTitle: 'Registrazione completata',
    registerSuccessSubtitle: 'I tuoi dati sono stati salvati correttamente.',
    errorRequiredFields: 'Nome, cognome e numero badge sono obbligatori.',
    errorRequiredFieldsNoBadge: 'Nome e cognome sono obbligatori.',
    registerNext: 'Avanti',
    back: 'Indietro',
    badgeScanTitle: 'Passa il badge',
    badgeScanInstruction: 'Passa il badge sul lettore per completare la registrazione.',
    badgeScanWaiting: 'In attesa del badge…',
    badgeScanInvalid: 'Lettura non valida: passa il badge sul lettore.',
    badgeManualButton: 'Inserisci a mano',
    badgeManualInstruction: 'Digita il numero del badge.',
    badgeManualBackLink: 'Torna alla lettura del badge',
    errorConsent: "Devi confermare di aver letto l'informativa privacy e sicurezza.",

    // Modale Timbra badge (NFC/codice)
    checkinTitle: 'Timbra badge',
    nfcInstruction: 'Avvicina il tuo badge al lettore NFC.',
    nfcPlaceholder: 'In attesa del badge…',
    useCodeLink: 'Non hai il badge con te? Inserisci il codice',
    codeInstruction: "Inserisci il codice univoco che ti ha fornito l'amministratore.",
    codePlaceholder: 'Codice',
    useNfcLink: 'Usa il badge NFC',
    welcomeBack: (nome, cognome) => `Bentornato/a, ${nome} ${cognome}.`,
    badgeSignaturePrompt: (nome, cognome) => `Ciao ${nome} ${cognome}, firma qui per confermare il tuo ingresso.`,
    chooseReferencePrompt: 'Chi vuoi avvisare del tuo arrivo?',
    chooseReferenceNone: 'Nessuno',

    // Modale Uscita
    exitTitle: 'Registra uscita',
    exitVerb: 'Conferma uscita',
    exitInstruction: 'Inserisci il tuo numero badge.',
    exitDoneTitle: 'Fatto',
    exitDoneSubtitle: 'Operazione registrata.',
    errorBadgeRequired: 'Inserisci il numero badge.',
    badgeNumberPlaceholder: 'N. badge',

    // Popup PDF privacy/sicurezza
    docPrivacyTitle: 'Informativa privacy',
    docSecurityTitle: 'Informativa sicurezza',
    docLoading: 'Caricamento del documento…',
    docGenericError: 'Documento non disponibile.',
    docConnError: 'Impossibile contattare il server. Verifica la connessione e riprova.',
    docOpenNewTab: 'Apri il documento in una nuova scheda ↗',
    docAutoOpenNote: 'Il documento si sta aprendo. Una volta chiuso, torna qui: questa finestra si chiuderà da sola.',
    fieldSignature: 'Firma',
    signatureClear: 'Cancella firma',
    signatureHint: 'Firma qui con il dito o il pennino',
    errorSignatureRequired: 'La firma è obbligatoria per completare la registrazione.',
    contactsSubtitle: 'Raccolta contatti',
    contactsFormTitle: 'Lasciaci il tuo contatto',
    contactsFormSubtitle: 'Compila i tuoi dati, ti ricontatteremo presto.',
    contactsSuccessTitle: 'Grazie!',
    contactsSuccessSubtitle: 'Il tuo contatto è stato registrato con successo.',
    contactsNewButton: 'Nuovo contatto',
    contactsSubmitButton: 'Invia',
    contactsErrorRequired: 'Nome, cognome ed email sono obbligatori.',
    contactsErrorPrivacy: "Devi accettare l'informativa privacy.",
  },
  en: {
    // Main panel
    kioskSubtitle: 'Entry station',
    btnRegister: 'Register',
    btnBadge: 'Badge',
    btnExit: 'Exit',
    adminLink: 'Administrator access',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',

    // Register modal
    registerTitle: 'Register',
    registerSubtitle: 'Fill in your details to complete the registration.',
    fieldNome: 'First name *',
    fieldCognome: 'Last name *',
    fieldBadge: 'Badge number *',
    fieldRiferimento: 'Reference person',
    fieldEmail: 'Email',
    fieldNote: 'Notes',
    emailPlaceholder: 'name@example.com',
    emailHint: "Optional: if you provide it, we'll send you a copy of the privacy and security notices by email.",
    referenceSelectedHint: 'The selected person will receive an email notification.',
    fieldDitta: 'Company',
    fieldTelefono: 'Phone',
    fieldRuolo: 'Role',
    fieldDocumentType: 'Document type',
    fieldDocumentNumber: 'Document number',
    docTypePlaceholder: 'Select…',
    docTypeIdCard: 'ID card',
    docTypeLicense: "Driver's license",
    docTypePassport: 'Passport',
    optional: '(optional)',
    consentPrivacyPrefix: 'I have read and accept the ',
    linkPrivacy: 'privacy notice',
    linkSecurity: 'security notice',
    consentToRead: 'Tap to read and accept',
    consentDone: 'Read and accepted',
    docAcceptButton: 'I have read, I accept',
    submitting: 'Submitting…',
    registerSuccessTitle: 'Registration completed',
    registerSuccessSubtitle: 'Your details have been saved successfully.',
    errorRequiredFields: 'First name, last name and badge number are required.',
    errorRequiredFieldsNoBadge: 'First name and last name are required.',
    registerNext: 'Next',
    back: 'Back',
    badgeScanTitle: 'Tap your badge',
    badgeScanInstruction: 'Tap your badge on the reader to complete the registration.',
    badgeScanWaiting: 'Waiting for badge…',
    badgeScanInvalid: 'Invalid reading: please tap your badge on the reader.',
    badgeManualButton: 'Enter manually',
    badgeManualInstruction: 'Type the badge number.',
    badgeManualBackLink: 'Back to badge reading',
    errorConsent: 'You must confirm that you have read the privacy and security notice.',

    // Badge check-in modal (NFC/code)
    checkinTitle: 'Tap badge',
    nfcInstruction: 'Hold your badge near the NFC reader.',
    nfcPlaceholder: 'Waiting for badge…',
    useCodeLink: "Don't have your badge? Enter the code",
    codeInstruction: 'Enter the unique code provided by the administrator.',
    codePlaceholder: 'Code',
    useNfcLink: 'Use NFC badge',
    welcomeBack: (nome, cognome) => `Welcome back, ${nome} ${cognome}.`,
    badgeSignaturePrompt: (nome, cognome) => `Hi ${nome} ${cognome}, sign here to confirm your entry.`,
    chooseReferencePrompt: 'Who would you like to let know you have arrived?',
    chooseReferenceNone: 'No one',

    // Exit modal
    exitTitle: 'Log exit',
    exitVerb: 'Confirm exit',
    exitInstruction: 'Enter your badge number.',
    exitDoneTitle: 'Done',
    exitDoneSubtitle: 'Recorded successfully.',
    errorBadgeRequired: 'Enter your badge number.',
    badgeNumberPlaceholder: 'Badge no.',

    // Privacy/security PDF popup
    docPrivacyTitle: 'Privacy notice',
    docSecurityTitle: 'Security notice',
    docLoading: 'Loading document…',
    docGenericError: 'Document not available.',
    docConnError: 'Unable to reach the server. Check your connection and try again.',
    docOpenNewTab: 'Open document in a new tab ↗',
    docAutoOpenNote: 'The document is opening. Once you close it, come back here: this window will close automatically.',
    fieldSignature: 'Signature',
    signatureClear: 'Clear signature',
    signatureHint: 'Sign here with your finger or stylus',
    errorSignatureRequired: 'A signature is required to complete the registration.',
    contactsSubtitle: 'Contact collection',
    contactsFormTitle: 'Leave us your contact',
    contactsFormSubtitle: "Fill in your details, we'll get back to you soon.",
    contactsSuccessTitle: 'Thank you!',
    contactsSuccessSubtitle: 'Your contact has been registered successfully.',
    contactsNewButton: 'New contact',
    contactsSubmitButton: 'Submit',
    contactsErrorRequired: 'First name, last name and email are required.',
    contactsErrorPrivacy: 'You must accept the privacy notice.',
  },
  ro: {
    // Panou principal
    kioskSubtitle: 'Punct de intrare',
    btnRegister: 'Înregistrare',
    btnBadge: 'Badge',
    btnExit: 'Ieșire',
    adminLink: 'Acces administrator',
    cancel: 'Anulează',
    close: 'Închide',
    confirm: 'Confirmă',

    // Fereastra de înregistrare
    registerTitle: 'Înregistrare',
    registerSubtitle: 'Completați datele pentru a finaliza înregistrarea.',
    fieldNome: 'Prenume *',
    fieldCognome: 'Nume *',
    fieldBadge: 'Număr badge *',
    fieldRiferimento: 'Persoană de contact',
    fieldEmail: 'E-mail',
    fieldNote: 'Observații',
    emailPlaceholder: 'nume@exemplu.ro',
    emailHint: 'Opțional: dacă îl completați, vă trimitem pe e-mail o copie a informărilor privind confidențialitatea și securitatea.',
    referenceSelectedHint: 'Persoana selectată va primi o notificare prin e-mail.',
    fieldDitta: 'Companie',
    fieldTelefono: 'Telefon',
    fieldRuolo: 'Funcție',
    fieldDocumentType: 'Tip document',
    fieldDocumentNumber: 'Număr document',
    docTypePlaceholder: 'Selectați…',
    docTypeIdCard: 'Carte de identitate',
    docTypeLicense: 'Permis de conducere',
    docTypePassport: 'Pașaport',
    optional: '(opțional)',
    consentPrivacyPrefix: 'Am citit și accept ',
    linkPrivacy: 'informarea privind confidențialitatea',
    linkSecurity: 'informarea privind securitatea',
    consentToRead: 'Atingeți pentru a citi și a accepta',
    consentDone: 'Citită și acceptată',
    docAcceptButton: 'Am citit, accept',
    submitting: 'Se trimite…',
    registerSuccessTitle: 'Înregistrare finalizată',
    registerSuccessSubtitle: 'Datele dumneavoastră au fost salvate cu succes.',
    errorRequiredFields: 'Prenumele, numele și numărul badge-ului sunt obligatorii.',
    errorRequiredFieldsNoBadge: 'Prenumele și numele sunt obligatorii.',
    registerNext: 'Continuă',
    back: 'Înapoi',
    badgeScanTitle: 'Apropiați badge-ul',
    badgeScanInstruction: 'Apropiați badge-ul de cititor pentru a finaliza înregistrarea.',
    badgeScanWaiting: 'Se așteaptă badge-ul…',
    badgeScanInvalid: 'Citire nevalidă: apropiați badge-ul de cititor.',
    badgeManualButton: 'Introduceți manual',
    badgeManualInstruction: 'Introduceți numărul badge-ului.',
    badgeManualBackLink: 'Înapoi la citirea badge-ului',
    errorConsent: 'Trebuie să confirmați că ați citit informările privind confidențialitatea și securitatea.',

    // Fereastra de marcare badge (NFC/cod)
    checkinTitle: 'Scanare badge',
    nfcInstruction: 'Apropiați badge-ul de cititorul NFC.',
    nfcPlaceholder: 'Se așteaptă badge-ul…',
    useCodeLink: 'Nu aveți badge-ul la dumneavoastră? Introduceți codul',
    codeInstruction: 'Introduceți codul unic primit de la administrator.',
    codePlaceholder: 'Cod',
    useNfcLink: 'Folosiți badge-ul NFC',
    welcomeBack: (nome, cognome) => `Bine ați revenit, ${nome} ${cognome}.`,
    badgeSignaturePrompt: (nome, cognome) => `Bună ziua, ${nome} ${cognome}, semnați aici pentru a confirma intrarea.`,
    chooseReferencePrompt: 'Pe cine doriți să anunțați că ați sosit?',
    chooseReferenceNone: 'Pe nimeni',

    // Fereastra de ieșire
    exitTitle: 'Înregistrare ieșire',
    exitVerb: 'Confirmă ieșirea',
    exitInstruction: 'Introduceți numărul badge-ului.',
    exitDoneTitle: 'Gata',
    exitDoneSubtitle: 'Operațiune înregistrată.',
    errorBadgeRequired: 'Introduceți numărul badge-ului.',
    badgeNumberPlaceholder: 'Nr. badge',

    // Fereastra PDF confidențialitate/securitate
    docPrivacyTitle: 'Informare privind confidențialitatea',
    docSecurityTitle: 'Informare privind securitatea',
    docLoading: 'Se încarcă documentul…',
    docGenericError: 'Document indisponibil.',
    docConnError: 'Nu se poate contacta serverul. Verificați conexiunea și încercați din nou.',
    docOpenNewTab: 'Deschideți documentul într-o filă nouă ↗',
    docAutoOpenNote: 'Documentul se deschide. După ce îl închideți, reveniți aici: această fereastră se va închide automat.',
    fieldSignature: 'Semnătură',
    signatureClear: 'Șterge semnătura',
    signatureHint: 'Semnați aici cu degetul sau cu stylusul',
    errorSignatureRequired: 'Semnătura este obligatorie pentru a finaliza înregistrarea.',
    contactsSubtitle: 'Colectare contacte',
    contactsFormTitle: 'Lăsați-ne datele dumneavoastră de contact',
    contactsFormSubtitle: 'Completați datele, vă vom contacta în curând.',
    contactsSuccessTitle: 'Mulțumim!',
    contactsSuccessSubtitle: 'Datele dumneavoastră de contact au fost înregistrate cu succes.',
    contactsNewButton: 'Contact nou',
    contactsSubmitButton: 'Trimite',
    contactsErrorRequired: 'Prenumele, numele și e-mailul sunt obligatorii.',
    contactsErrorPrivacy: 'Trebuie să acceptați informarea privind confidențialitatea.',
  },
};
